import { createContext } from 'react';

const AgentConsumptionContext = createContext();

export default AgentConsumptionContext;
